export default __webpack_public_path__ + "static/lb2-09edda7ff2abc5f3388ed911ef3eb3e7.webp";